/**
 * Perfis de demonstracao.
 *
 * Mesma ideia do modo demo de aplicativos financeiros: escolher um perfil
 * pronto e entrar direto, sem cadastro. Aqui isso vale duas vezes, porque a
 * demonstracao usa exclusivamente saldo virtual — nenhum dado destes perfis
 * corresponde a pessoa, conta ou dinheiro real.
 */
import type { GameType } from './adapter.ts';

export interface DemoProfile {
  readonly id: string;
  readonly nome: string;
  readonly apelido: string;
  readonly descricao: string;
  readonly saldoVirtualCents: number;
  readonly partidas: number;
  readonly vitorias: number;
  readonly jogoFavorito: GameType;
  /** Forca do adversario nas partidas deste perfil. */
  readonly skillAdversario: number;
  readonly avatar: string;
}

export const DEMO_PROFILES: readonly DemoProfile[] = [
  {
    id: 'iniciante',
    nome: 'Primeira mesa',
    apelido: 'Bia',
    descricao: 'Está aprendendo. Adversário leve e partidas curtas.',
    saldoVirtualCents: 1_000_000,
    partidas: 4,
    vitorias: 2,
    jogoFavorito: 'TIC_TAC_TOE',
    skillAdversario: 0.45,
    avatar: '♟',
  },
  {
    id: 'damista',
    nome: 'Damista de praça',
    apelido: 'Seu Nilton',
    descricao: 'Damas brasileiras, com captura obrigatória e lei da maioria.',
    saldoVirtualCents: 1_000_000,
    partidas: 137,
    vitorias: 91,
    jogoFavorito: 'CHECKERS',
    skillAdversario: 0.85,
    // ♛ e nao ⛃: o glifo de dama de damas nao existe em varias fontes
    // e vira tofu. Este ja e usado no tabuleiro para marcar a peca coroada.
    avatar: '♛',
  },
  {
    id: 'enxadrista',
    nome: 'Clube de xadrez',
    apelido: 'Marcos',
    descricao: 'Xadrez com regras completas: roque, en passant e promoção.',
    saldoVirtualCents: 1_000_000,
    partidas: 312,
    vitorias: 168,
    jogoFavorito: 'CHESS',
    skillAdversario: 0.95,
    avatar: '♞',
  },
];

export interface StakeOption {
  readonly cents: number;
  readonly rotulo: string;
}

export const STAKES: readonly StakeOption[] = [
  { cents: 500, rotulo: 'R$ 5' },
  { cents: 2_000, rotulo: 'R$ 20' },
  { cents: 5_000, rotulo: 'R$ 50' },
  { cents: 20_000, rotulo: 'R$ 200' },
];

export const RAKE_BPS = 500;

/** Quanto o vencedor leva: pote menos o rake, truncado para baixo. */
export function payoutCents(entryFeeCents: number, rakeBps = RAKE_BPS): number {
  const pote = entryFeeCents * 2;
  return pote - Math.floor((pote * rakeBps) / 10_000);
}

export function rakeCents(entryFeeCents: number, rakeBps = RAKE_BPS): number {
  return Math.floor((entryFeeCents * 2 * rakeBps) / 10_000);
}
